import { ClearRounded } from "@mui/icons-material";
import { Box, Button, ButtonGroup, CircularProgress, Dialog, DialogActions, IconButton, Stack, Typography } from "@mui/material";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import { getColDefaultValue } from "components/PimDashboard/data";
import { statusOptions, selectOptionsKeyName } from "data/globalData";
import { useEffect, useState } from "react";
import axios from "axios";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { shootSkuIcodeColumn } from "../../ShootsDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { grey } from "@mui/material/colors";
import HistoryVerticalStepper from "./HistoryVerticalStepper/HistoryVerticalStepper";
import HistoryTable from "./HistoryTable/HistoryTable ";

const SampleHistoryModal = ({ modal, setModal, skuDetails }) => {
	const { setLoadingOpen, setSnackBarOpen, setSnackBar, snackBar } = GlobalState();

	const [historyData, setHistoryData] = useState();
	const [loading, setLoading] = useState();
	const [viewMode, setViewMode] = useState("stepper"); // stepper | table

	const fetch = () => {
		setLoading(true);
		try {
			const res = axios.get(`/api/studio/studio_merchant_sample_history/${skuDetails[shootSkuIcodeColumn.key]}`);
			res.then((res) => {
				setHistoryData(res.data.result);
				setLoading(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
			});
		}
	};

	useEffect(() => {
		if (skuDetails?.[shootSkuIcodeColumn.key]) {
			fetch();
		}
	}, [skuDetails]);

	const handleModalclose = () => {
		setModal(false);
	};

	return (
		<Dialog maxWidth="lg" fullWidth open={modal} onClose={handleModalclose} component="form">
			<Box p={2} height="90vh">
				<Box
					sx={{ pl: 2, pr: 2, borderBottom: "1px solid #ccc" }}
					display="flex"
					justifyContent="space-between"
					alignItems="center">
					<Typography variant="subtitle1">SKU ICODE: {skuDetails?.[shootSkuIcodeColumn.key]}</Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>

				{loading ? (
					<Box display="flex" justifyContent="center" alignItems="center" height="50vh" width="100%">
						<CircularProgress />
					</Box>
				) : (
					<Box display="flex" justifyContent="space-around" width="100%" flexWrap="wrap">
						<Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
							<Typography variant="h6" color={grey[700]}>
								Updates
							</Typography>

							<ButtonGroup variant="contained" size="small">
								<Button color={viewMode === "stepper" ? "primary" : "inherit"} onClick={() => setViewMode("stepper")}>
									Stepper
								</Button>

								<Button color={viewMode === "table" ? "primary" : "inherit"} onClick={() => setViewMode("table")}>
									Table
								</Button>
							</ButtonGroup>
						</Box>
						<Box width="45%">
							<Typography p={1}>Merchant</Typography>
							{viewMode === "stepper" ? (
								<HistoryVerticalStepper steps={historyData?.merchant} />
							) : (
								<HistoryTable data={historyData?.merchant} />
							)}
						</Box>

						<Box width="45%">
							<Typography p={1}>Studio</Typography>
							{viewMode === "stepper" ? (
								<HistoryVerticalStepper steps={historyData?.studio} />
							) : (
								<HistoryTable data={historyData?.studio} />
							)}
						</Box>
					</Box>
				)}
			</Box>
		</Dialog>
	);
};

export default SampleHistoryModal;
